export default __webpack_public_path__ + "images/db40f21c34c05721bfc0dfb3dfeb7b85-acoustic.jpg";